import axios from "axios";
import { FC } from "react";
import { useConfig } from "./shared/hooks/useConfig";

export const PMAxiosConfig: FC = () => {
	const { apiUrl } = useConfig();

	axios.defaults.baseURL = apiUrl;
	axios.defaults.withCredentials = true;

	return null;
};
